import { Injectable } from '@angular/core';
import { ViewCategory } from '@ddt-web/config';
import { InjectConfig, PaConfigKey } from '@ddt-web/config-layer';
import { AudienceService } from '@ddt-web/data-service';
import * as isEmpty from 'lodash/isEmpty';

import { AbstractWorker } from '../models/abstract-worker';

@Injectable()
export class SetViewCategoryWorker extends AbstractWorker {

	@InjectConfig(PaConfigKey.ENABLE_PROPOSAL_VIEW) private readonly enableProposalViewCategory = false;

	constructor(
		private audienceService: AudienceService
	) {
		super();
	}

	public handle(queryParams: any): any {
		if (!isEmpty(queryParams)) {
			if (queryParams.engagement) {
				this.audienceService.setViewCategory(ViewCategory.FA_PLUS);
			} else if (this.enableProposalViewCategory && queryParams.portfolios?.length === 2 && !queryParams.acBenchmark) {
				this.audienceService.setViewCategory(ViewCategory.PROPOSAL);
			} else if (queryParams.portfolios) {
				this.audienceService.setViewCategory(ViewCategory.FA_SELF_SERVICE);
			} else if (queryParams.manuallySetViewCategory) {
				this.audienceService.setViewCategory(queryParams.manuallySetViewCategory);
			}
		}
	}
}
